import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

// Loader component 

function Loader() {
    const loaderStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000,
        backgroundColor: 'rgba(255, 255, 255, 0.7)'
    };

    return (
        <div style={loaderStyle}>
            <BeatLoader color="#135674" />
        </div>
    );
}

export default Loader;
